export interface FetchRegisterUserBody {
  userName: string;
  password: string;
  inviteCode: string;
}

export const fetchRegisterUser = async (callData: FetchRegisterUserBody) => {
  const body: FetchRegisterUserBody = {
    ...callData
  };

  const response = await fetch('api/v1/user', {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body)
  });

  if (!response.ok) {
    // Throw error so SWR can catch and store it
    throw new Error(`Error: ${response.statusText}`);
  }

  return await response.json();
};
